import { useEffect, useState } from "react";
import AudioPlayer from "../../../../components/AudioPlayer/AudioPlayer";
import LottieFromUrl from "../../../../components/LottieFromUrl/LottieFromUrl";
import { BreatheContent } from "../../../../hooks/useRetrieveBreatheExercise";
import "./CommonContent.scss";
import videoObjectJson from "../../../../appAssets/jsons/videoObject.json";
import YetiCharacter from "../../../Rooms/components/YetiCharacter/YetiCharacter";
import Lottie from "lottie-react";

function useTypewriter(text: string, speed = 45) {
  const [displayed, setDisplayed] = useState("");
  useEffect(() => {
    setDisplayed("");
    if (!text) return;
    let i = 0;
    const id = setInterval(() => {
      i++;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) clearInterval(id);
    }, speed);
    return () => clearInterval(id);
  }, [text, speed]);
  return displayed;
}

interface CommonContentProps {
  screenIndex: number;
  breatheContent: BreatheContent;
  isAudioPlaying?: boolean;
  isLoopMusic?: boolean;
}

function CommonContent({
  screenIndex,
  breatheContent,
  isAudioPlaying = true,
  isLoopMusic,
}: CommonContentProps) {
  const exercise = breatheContent.exercises[screenIndex];
  const displayedText = useTypewriter(exercise?.title ?? "");

  if (!exercise) return null;

  console.log("exerciseexerciseexercise", exercise?.audio);
  console.log("exercisebgMusic", screenIndex);

  return (
    <div
      className={`common-content${screenIndex === 3 ? " common-content--screen3" : ""}`}
    >
      <LottieFromUrl
        url={exercise?.images[0]?.url}
        className="common-content__yeti"
      />

      <p className="common-content__text">{displayedText}</p>
      {exercise.audio && isAudioPlaying && (
        <AudioPlayer
          uri={exercise.audio}
          autoPlay
          loop={!!isLoopMusic}
          variant="compact"
          className="common-content__audio"
        />
      )}
      {exercise.bgMusic && isAudioPlaying && (
        <AudioPlayer
          uri={exercise.bgMusic}
          autoPlay
          loop={!!isLoopMusic}
          variant="compact"
          className="common-content__audio"
        />
      )}
    </div>
  );
}

export default CommonContent;
